module.exports = __webpack_public_path__ + "img/beer_id-22.5267e450.png";